import { FC } from 'react';
import { useStepValidationFailed } from '../../containers/Apartment/Stepper/StepValidationContext';

interface FieldErrorTooltipProps {
    error?: string;
    visible: boolean;
}

const FieldErrorTooltip: FC<FieldErrorTooltipProps> = ({ error, visible }) => {
    const stepFailed = useStepValidationFailed();
    if (!(visible || (stepFailed && !!error))) return null;
    if (!error) return null;

    return (
        <div style={{
            position: 'relative',
            zIndex: 10,
        }}>
            {/* Tooltip body */}
            <div style={{
                marginTop: 4,
                display: 'inline-flex',
                alignItems: 'center',
                gap: 8,
                padding: '8px 12px',
                backgroundColor: '#fbfbfb',
                border: '1px solid #d4d4d4',
                borderRadius: 4,
                boxShadow: '0 2px 6px rgba(0,0,0,0.12)',
                fontFamily: 'CircularRegular, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: 13,
                color: '#333',
                lineHeight: 1.4,
            }}>
                {/* Warning icon */}
                <span style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: 18,
                    height: 18,
                    backgroundColor: '#e8910c',
                    borderRadius: 2,
                    color: '#fff',
                    fontSize: 13,
                    fontWeight: 700,
                    lineHeight: 1,
                    flexShrink: 0,
                }}>!</span>
                <span>{error}</span>
            </div>
        </div>
    );
};

export default FieldErrorTooltip;
